// import { Provider } from '@prisma/client'
import { useMemo } from 'react'
import { ProviderClient } from '../../providers/abstract/provider.client'
import { useProviders } from './useProviders'

type Props = {
  provider?: any
  providerKey?: string
}

export const useProvider = ({ provider, providerKey }: Props) => {
  const providers = useProviders()

  const providerClient: ProviderClient = useMemo(() => {
    return providers[providerKey ?? provider?.name]
  }, [providers, provider, providerKey])

  const getTrigger = (key: string) => {
    const triggers = providerClient?.description?.triggers ?? []

    return triggers.find(trigger => trigger.key === key)
  }

  const getAction = (key: string) => {
    const actions = providerClient?.description?.actions ?? []

    return actions.find(action => action.key === key)
  }

  const canConnectAccount = () => {
    const authentication = providerClient?.authentication

    if (!authentication) {
      return false
    }

    if (authentication.type === 'oauth2' || authentication.type === 'nango') {
      return true
    }

    if (!authentication.inputs) {
      return false
    }

    return authentication.inputs.length > 0
  }

  return {
    providerClient,
    getTrigger,
    getAction,
    canConnectAccount,
  }
}
